import React, { Component } from 'react'
import { Row, Col, Card, Button, Container, Form, Modal } from "react-bootstrap";
import { Document, Page } from 'react-pdf';
import moment, { invalid } from "moment";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import "./_assignment.scss";
import gql from "graphql-tag";
import { graphql } from "react-apollo";


const ADD_ASSIGNMENT_LECTURER_RETURN_DATA = gql`
  mutation($params: AssignmentLecturerReturnInput) {
    addAssignmentLecturerReturnData(params: $params)
  }`



class StudentDetailsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
            pageNumber: 1,
            dataClear: 0,
            employeecomment:"",
            employeecommentError:"",
            loader: 0,
            submitError: "",
            submitted: false,
            mark:"",
            markError:"",
            isDisabled: false,
        };
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    };


    handleSubmit = e => {

        if (this.state.mark == "") {
            this.setState({ markError: "Please give the mark", })
            return ""
        }

        if (this.state.employeecomment == "") {
            this.setState({employeecommentError: "Please write the comments", })
            return ""
        }

        this.setState({
            loader: 1
        });

        const params = {
            id: parseInt(this.props.stateData.individualStudentData.dairyAssignmentStatus_id),
            verified_by: parseInt(Cookies.get("id")),
            verifier_comments: this.state.employeecomment,
            marks: parseInt(this.state.mark),
        };




        this.addAssignmentLecturerReturnData(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message),
                loader: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
        this.setState({ loader: 1 })
    };

    addAssignmentLecturerReturnData = async (
        params) => {
        await this.props.addAssignmentLecturerReturnData({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.addAssignmentLecturerReturnData) {
                    this.setState({
                        loader: 0,
                        submitted: true
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }
        });
    };


    handleChange = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (name == "mark") {
            this.setState({
                mark: value,
                markError:""
            })
        }
        if (name == "employeecomment") {
            this.setState({
                employeecomment: value,
                employeecommentError:""
            })
        }
        this.setState({ [name]: value });
    }

    render() {

        console.log(this.props.stateData.individualStudentData.dairyAssignmentStatus_id, "nock")
        console.log(this.props.stateData.individualStudentData, "mmmmmm")

        console.log("pppppppp",this.state)

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="modal-title">Student Assignment Details</Modal.Title>
                </Modal.Header>
                {
                    this.props.stateData.blockType == "2" || this.props.stateData.individualStudentData.status == "2" ?
                        (
                            <>
                                <Modal.Body className="p-4">
                                    <Container fluid>
                                        <Row className="">
                                            <Col as={Col} lg={6} md={12} sm={12}>
                                                <p className="font-weight-bold f-18 mt-2"> Student Name: <span className="f-18">{this.props.stateData.individualStudentData.student_name}</span></p>
                                            </Col>
                                            <Col as={Col} lg={6} md={12} sm={12}>
                                                <p className="font-weight-bold f-18 mt-2">Roll No. : <span className="f-18">{this.props.stateData.individualStudentData.roll_no}</span></p>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col as={Col} lg={6} md={12} sm={12} className=''>
                                                <p className='font-weight-bold f-18'>Comments:</p>
                                                <span><textarea value={this.props.stateData.individualStudentData.comments} disabled={true} style={{ width: "300px", height: "50px" }}></textarea></span>
                                            </Col>
                                            <Col as={Col} lg={6} md={12} sm={12} className=''>
                                                <p className='font-weight-bold f-18'>Marks:</p>
                                                <input type='number' className='form-control markk' placeholder="Enter Marks" name="mark" onChange={this.handleChange} value={this.props.stateData && this.props.stateData.individualStudentData.marks} disabled={this.props.stateData && this.props.stateData.individualStudentData.marks}/>
                                                <span className="text-danger">{this.state.markError}</span>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col as={Col} lg={6} md={12} sm={12} className=''>
                                                <p className='font-weight-bold f-18'>Lecturer Comment:</p>
                                                <textarea className='form-control' type="text" value={this.props.stateData && this.props.stateData.individualStudentData.verifier_comments ? this.props.stateData && this.props.stateData.individualStudentData.verifier_comments : this.state.employeecomment } name="employeecomment" onChange={this.handleChange} style={{ width: "300px" }} disabled={this.props.stateData && this.props.stateData.individualStudentData.verifier_comments}></textarea>
                                                <span className="text-danger">{this.state.employeecommentError}</span>
                                            </Col>
                                            <Col as={Col} lg={6} md={12} sm={12}> 
                                            {this.props.stateData && this.props.stateData.individualStudentData.marks && this.props.stateData && this.props.stateData.individualStudentData.verifier_comments ? null :  <Button className='btn btn-success text-uppercase' style={{ marginTop: "37px" }} onClick={this.handleSubmit} >
                                                    {
                                                        this.state.loader == 1 ? (
                                                            <span className="spinner-border spinner-border-sm"></span>
                                                        ) : ""
                                                    }Submit</Button>}
                                               
                                                <div className='d-block'>
                                                    {
                                                        this.state.submitted == true ? (
                                                            <p className="text-success mt-1" >Submitted Successfully</p>
                                                        ) : ""
                                                    }
                                                    {
                                                        this.state.submitError != "" ? (
                                                            <span className="text-danger mt-1">{this.state.submitError}</span>
                                                        ) : ("")
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='mt-3'>
                                            <Col as={Col} lg={12} md={12} sm={12} className=''>
                                                <div className="pdf-container" style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                                    <p className='font-weight-bold f-18 text-center mt-3'>Assignment Details:</p>
                                                    <Document
                                                        file={this.props.stateData.individualStudentData.upload_file_path}
                                                        onLoadSuccess={({ numPages }) => this.setState({ numPages })}
                                                    >
                                                        {Array.from(new Array(this.state.numPages), (el, index) => (
                                                            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={700} />
                                                        ))}
                                                    </Document>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Modal.Body>
                            </>
                        ) : ""
                }

            </Modal>)
    }
}



export default
    withRouter(withApollo(
        graphql(ADD_ASSIGNMENT_LECTURER_RETURN_DATA, {
            name: "addAssignmentLecturerReturnData"
        })
            (StudentDetailsModal)));
